import React, { FC } from 'react'

//@ts-ignore
// import LKFetcherButton from 'shared/LKFetcherButton'
import { actions as DCActions } from '../../../DetailsContainer'

import translate from '../../translator'

import { UndoLoanBlockButtonProps } from '../../types.LoanDetails'
import LKFetcherButton from 'src/features/shared/LKFetcherButtonNew'
import { undoLoanBlock } from 'src/store/loan'

const UndoLoanBlockButton: FC<UndoLoanBlockButtonProps> = ({ type, ID, hash, disabled }) => (
  // <LKFetcherButton
  //   fetcherName={`Loan-${ID}-UndoBlockLoan`}
  //   APICall={Loan.loanOper}
  //   disabled={disabled}
  //   params={{
  //     LoanID: ID,
  //     HashSum_LoanID_: hash,
  //     page: 'arrestundo',
  //   }}
  //   successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
  //   style={{ display: 'flex', marginLeft: 'auto' }}
  //   alias="bullet_red_delete"
  //   permission="LOAN_DELETE_ARREST"
  // >
  //   {translate('cmd_delete_arrest')}
  // </LKFetcherButton>

  //UPDATED API REQUEST loan_oper_api page: arrestundo
  <LKFetcherButton
    buttonAction={undoLoanBlock}
    actionName={`Loan-${ID}-UndoBlockLoan`}
    disabled={disabled}
    params={{
      LoanID: ID,
      HashSum_LoanID_: hash,
    }}
    successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
    style={{ display: 'flex', marginLeft: 'auto' }}
    alias="bullet_red_delete"
    permission="LOAN_DELETE_ARREST"
  >
    {translate('cmd_delete_arrest')}
  </LKFetcherButton>
)

export default UndoLoanBlockButton
